"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagGroupColor = void 0;
var TagGroupColor;
(function (TagGroupColor) {
    TagGroupColor["Yellow"] = "#EFF82E";
    TagGroupColor["Blue"] = "#18EBFD";
    TagGroupColor["Pink"] = "#FF90FB";
    TagGroupColor["Red"] = "#FE5353";
    TagGroupColor["Orange"] = "#FEA427";
    TagGroupColor["Green"] = "#2AF525";
    TagGroupColor["Purple"] = "#888CFC";
    TagGroupColor["Gray"] = "#B9B9B9";
})(TagGroupColor = exports.TagGroupColor || (exports.TagGroupColor = {}));
